export class Banner {
    constructor(
        public url: string,
        public smallUrl: string,
        ) {
    }
}
